import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { getColumns } from "./resources";
import Structure from "./components/Structure";
import { selectedArticles } from "../../../../../store/Concept/selectors";

const Table = () => {
  const columns = useMemo(() => getColumns(), []);
  const data = useSelector(selectedArticles);

  return <Structure columns={columns} data={data} />;
};

export default Table;
